import { PharmacyHours } from "./PharmacyHours.js";
import { PharmacyInfoCompact } from "./PharmacyInfoCompact.js";
import { useTranslation } from "react-i18next";
import { Address, Caption, ConditionalComponent, Delivery, Distance, Flex, IconFavorite, PhoneNumber, Stack, Subtitle1, ToggleButton, Website } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";
import { useAuthContext } from "@myphx-engineering/auth/client";

//#region src/components/pharmacy-info/PharmacyInfo.tsx
/**
* The PharmacyInfo component is a display of information specific to a certain location. It can either be an interactive component or non-interactive display of available information.
*/
const PharmacyInfo = ({ name, shippingTime, address, distance, phone, compact = false, hours, day, weeklyHours, url, locale = "en-US", favorite = false, toggleFavorite, showAfterShipmentText = true }) => {
	const { isAuthenticated } = useAuthContext();
	const { t } = useTranslation("phx-lib");
	const shippingTimeText = showAfterShipmentText ? t("pharmacyInfo.delivery.shippingTime", { shippingTime }) : t("pharmacyInfo.delivery.shippingTimeWithoutAfterShipment", { shippingTime });
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "sm",
		"data-testid": "pharmacy-info",
		children: [/* @__PURE__ */ jsxs(Flex, {
			align: "center",
			justify: "space-between",
			children: [/* @__PURE__ */ jsx(Subtitle1, {
				"data-testid": "pharmacy-name",
				children: name
			}), /* @__PURE__ */ jsx(ConditionalComponent, {
				condition: isAuthenticated && !!toggleFavorite,
				children: /* @__PURE__ */ jsx(ToggleButton, {
					checked: favorite,
					disabled: false,
					Icon: IconFavorite,
					CheckedIcon: IconFavorite,
					iconProps: { filled: favorite },
					color: favorite ? "error" : "gray",
					toggle: toggleFavorite
				})
			})]
		}), compact ? /* @__PURE__ */ jsx(PharmacyInfoCompact, {
			address,
			distance,
			phone,
			hours,
			locale
		}) : /* @__PURE__ */ jsxs(Stack, {
			gap: "sm",
			children: [
				address ? /* @__PURE__ */ jsx(Address, { address }) : null,
				distance ? /* @__PURE__ */ jsx(Distance, {
					...distance,
					locale
				}) : null,
				shippingTime ? /* @__PURE__ */ jsx(Delivery, { shippingTime: shippingTimeText }) : null,
				phone ? /* @__PURE__ */ jsx(PhoneNumber, { phone }) : null,
				url ? /* @__PURE__ */ jsx(Website, { url }) : null,
				shippingTime ? /* @__PURE__ */ jsx(Caption, { children: t("pharmacyInfo.delivery.disclaimer") }) : null,
				hours ? /* @__PURE__ */ jsx(PharmacyHours, {
					weeklyHours,
					hours,
					day
				}) : null
			]
		})]
	});
};

//#endregion
export { PharmacyInfo };